export const department = [
  {
    id: 1,
    value: "Chi nhánh Tân Sơn Nhất",
  },
  {
    id: 2,
    value: "Chi nhánh Nội Bài",
  },
  {
    id: 3,
    value: "Chi nhánh Đà Nẵng",
  },
  {
    id: "IT",
    value: "Phòng Công nghệ thông tin",
  },
  {
    id: "OAP",
    value: "Phòng Tổ chức và nhân lực",
  },
  {
    id: "ECO",
    value: "Phòng Kinh doanh",
  },
  {
    id: "CO",
    value: "Văn phòng công ty",
  },
  {
    id: "IP",
    value: "Phòng Kế hoạch đầu tư",
  },
  {
    id: "AF",
    value: "Phòng Tài chính kế toán",
  },
  {
    id: "TC",
    value: "Trung tâm đào tạo",
  },
  {
    id: "SCBD",
    value: "Trung tâm SC&BD TTB",
  },
  {
    id: "CC",
    value: "Trung tâm Kiểm soát tải",
  },
  {
    id: "SQ",
    value: "Phòng An toàn chất lượng và An ninh",
  },
];

export const unitTSN = [
  {
    id: "BGD1",
    value: "Ban Giám đốc",
  },
  {
    id: "HQ1",
    value: "Trung tâm điều hành",
  },
  {
    id: "PSC1",
    value: "Trung tâm phục vụ sân đỗ",
  },
  {
    id: "PVHK1",
    value: "Trung tâm phục vụ hành khách",
  },
  {
    id: "GA1",
    value: "Nhóm hành chính tổng hợp",
  },
];

export const unitNB = [
  {
    id: "BGD2",
    value: "Ban Giám đốc",
  },
  {
    id: "HQ2",
    value: "Trung tâm điều hành",
  },
  {
    id: "PSC2",
    value: "Trung tâm phục vụ sân đỗ",
  },
  {
    id: "PVHK2",
    value: "Trung tâm phục vụ hành khách",
  },
  {
    id: "AP2",
    value: "Phòng Kế hoạch hành chính",
  },
  {
    id: "KT2",
    value: "Phòng Kế toán",
  },
];

export const unitDN = [
  {
    id: "BGD3",
    value: "Ban Giám đốc",
  },
  {
    id: "HQ3",
    value: "Trung tâm điều hành",
  },
  {
    id: "PSC3",
    value: "Trung tâm phục vụ sân đỗ",
  },
  {
    id: "PVHK3",
    value: "Trung tâm phục vụ hành khách",
  },
  {
    id: "AP3",
    value: "Phòng Kế hoạch hành chính",
  },
  {
    id: "KT3",
    value: "Phòng Kế toán",
  },
  {
    id: "PVHH3",
    value: "Trung tâm phục vụ hàng hóa",
  },
];

export const psc2Team = [
  {
    id: "SD1",
    value: "Đội dịch vụ sân đỗ",
  },
  {
    id: "SD2",
    value: "Đội dịch vụ kỹ thuật",
  },
  {
    id: "SD3",
    value: "Đội cung ứng vật tư",
  },
  {
    id: "SD4",
    value: "Đội dịch vụ trên tàu",
  },
  {
    id: "SD5",
    value: "Văn phòng trung tâm phục sân đỗ",
  },
];

export const pvhk2Team = [
  {
    id: "PVHK1",
    value: "Đội phục vụ hành khách VNA quốc nội",
  },
  {
    id: "PVHK2",
    value: "Đội phục vụ hành khách VNA quốc tế",
  },
  {
    id: "PVHK3",
    value: "Đội phục vụ hành khách đến và chuyển tiếp",
  },
  {
    id: "PVHK4",
    value: "Đội vé sân bay",
  },
  {
    id: "PVHK5",
    value: "Đội phục vụ hành khách quốc tế 1",
  },
  {
    id: "PVHK6",
    value: "Đội phục vụ hành lý",
  },
  {
    id: "PVHK7",
    value: "Văn phòng trung tâm phục vụ hành khách",
  },
];

export const hq2Team = [
  {
    id: "HQ1",
    value: "Trực ban điều hành",
  },
  {
    id: "HQ2",
    value: "Đội hướng dẫn chất xếp",
  },
  {
    id: "HQ3",
    value: "Đội xe đưa đón phi công tiếp viên",
  },
  {
    id: "HQ4",
    value: "Đội xe điều hành",
  },
  {
    id: "HQ5",
    value: "Tổ quản lý chất lượng ",
  },
  {
    id: "HQ6",
    value: "Văn phòng trung tâm điều hành",
  },
];

export const hq1Team = [
  {
    id: "HQ1",
    value: "Trực ban điều hành",
  },
  {
    id: "HQ2",
    value: "Đội hướng dẫn chất xếp",
  },
  {
    id: "HQ5",
    value: "Tổ quản lý chất lượng ",
  },
  {
    id: "HQ6",
    value: "Đội xe phục vụ tổ bay",
  },
  {
    id: "HQ7",
    value: "Văn phòng trung tâm điều hành",
  },
];

export const psc1Team = [
  {
    id: "SD1",
    value: "Đội dịch vụ sân đỗ",
  },
  {
    id: "SD2",
    value: "Đội dịch vụ kỹ thuật",
  },
  {
    id: "SD3",
    value: "Đội cung ứng vật tư",
  },
  {
    id: "SD4",
    value: "Đội dịch vụ trên tàu",
  },
  {
    id: "SD5",
    value: "Văn phòng trung tâm phục vụ sân đỗ",
  },
];

export const pvhk1Team = [
  {
    id: "PVHK1",
    value: "Đội phục vụ hành khách VNA quốc nội",
  },
  {
    id: "PVHK2",
    value: "Đội phục vụ hành khách VNA quốc tế",
  },
  {
    id: "PVHK3",
    value: "Đội phục vụ hành khách đến và chuyển tiếp",
  },
  {
    id: "PVHK4",
    value: "Đội vé sân bay",
  },
  {
    id: "PVHK6",
    value: "Đội phục vụ hành lý",
  },
  {
    id: "PVHK7",
    value: "Đội phục vụ hành khách các hãng",
  },
  {
    id: "PVHK8",
    value: "Văn phòng trung tâm phục vụ hành khách",
  },
];

export const psc3Team = [
  {
    id: "SD1",
    value: "Đội dịch vụ sân đỗ",
  },
  {
    id: "SD2",
    value: "Đội dịch vụ kỹ thuật",
  },
  {
    id: "SD4",
    value: "Đội dịch vụ trên tàu",
  },
  {
    id: "SD5",
    value: "Văn phòng trung tâm phục vụ sân đỗ",
  },
];

export const pvhk3Team = [
  {
    id: "PVHK1",
    value: "Đội phục vụ hành khách VNA quốc nội",
  },
  {
    id: "PVHK2",
    value: "Đội phục vụ hành khách VNA quốc tế",
  },
  {
    id: "PVHK4",
    value: "Đội vé sân bay",
  },
  {
    id: "PVHK6",
    value: "Đội phục vụ hành lý",
  },
  {
    id: "PVHK7",
    value: "Văn phòng trung tâm phục vụ hành khách",
  },
];

export const hq3Team = [
  {
    id: "HQ5",
    value: "Tổ quản lý chất lượng ",
  },
  {
    id: "HQ6",
    value: "Đội điều hành",
  },
  {
    id: "HQ7",
    value: "Văn phòng trung tâm điều hành",
  },
];
